module.exports = __webpack_public_path__ + "img/r-t.de96fd31.png";